var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.mTag,{tag:"component",staticClass:"base-text",class:[_vm.baseClass, `text-${_vm.color}`],style:({ '--font-weight': _vm.fontWeight })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }